module.exports = __webpack_public_path__ + "img/lg_ring_y_s_1_null@2x.7a6fea0e.png";